import {useEffect} from "react";
import {gsap} from "gsap";
import {MotionPathPlugin} from "gsap/MotionPathPlugin";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import useBreakpoint from "../../hooks/useBreakpoint";
import GenericLottie from "../../components/GenericLotti";
import Content from "../../components/Content";
import Process from "../../components/Process";
import curvedArrow from "../../assets/misc/curvedArrow.svg";
import arrowElement from '../../assets/elements/arrowElement.svg';
import switchElement from '../../assets/elements/switch2.svg';
import plus from '../../assets/elements/plus.svg';
import tinyArrow from '../../assets/elements/tinyArrow.svg';
import arrow from '../../assets/misc/curvedArrowLeft.svg';
import bottle from '../../assets/lotties/bottle.json';
import phone from '../../assets/lotties/phone.json';
import floor from '../../assets/elements/floor.svg';
import star1 from '../../assets/elements/star1.svg';
import star2 from '../../assets/elements/star2.svg';
import {kickOff, research, ux, ui, header, brilliant, notGoingAnywhere} from "./constants";


export default function DesignProcess({footerRef}) {

    const point = useBreakpoint();


    useEffect(() => {

        gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
        gsap.core.globals("ScrollTrigger", ScrollTrigger);
        gsap.core.globals("MotionPathPlugin", MotionPathPlugin);

        // special definition of 'duration'
        // of the scrubbed ScrollTrigger animation
        // The higher the value, the slower the animation
        // let scrollDist = 4;

        gsap.set('#scrollDist', {
            width: '100%',
            height: `${point === 'lg' ? '1852' : '2500'}`,
        })

        let map = document.getElementById('map'),
            mapWidth = map.getBoundingClientRect().width,
            mapHeight = map.getBoundingClientRect().height;

        gsap.set('#container', {
            position: 'absolute',
            width: mapWidth,
            height: mapHeight,
            left: '50%',
            xPercent: -50,
            top: 0,
            autoAlpha: 1
        })

        // based on duration of scrubbed timeline (= 1 sec) the staggerTimes for revealing objects (determined by the values of ST onUpdate progress)
        // let staggerTimes = [0.125, 0.305, 0.390, 0.560, 0.625, 0.815, 0.98];

        //tween the theRoute + thePoint
        gsap.timeline({
            defaults: {duration: 1, ease: 'none'},
            onComplete: final,
            scrollTrigger: {
                trigger: '#scrollDist',
                start: `${point === 'lg' ? 'top top' : '+=200'}`,
                end: `${point === 'lg' ? '+=1852' : '+=2500'}`,
                scrub: 0.3,
                //info for position = progress
                // onUpdate: ({progress}) => {
                //     console.log(progress)
                // },
                //invalidateOnRefresh: true
                // markers: true
            }
        })
            .to('#thePoint', {
                motionPath: {
                    path: `${point === 'lg' ? '#theRoute' : '#theRouteMobile'}`,
                    align: `${point === 'lg' ? '#theRoute' : '#theRouteMobile'}`,
                    alignOrigin: [0.5, 0.5],
                },
            }, 0)
            .from(`${point === 'lg' ? '#theRoute' : '#theRouteMobile'}`, {drawSVG: '0 0'}, 0) // , 0.0045
            .from('.stop', {
                autoAlpha: 0, y: '-=100',
                duration: 0.005,
                // stagger: function (index) {
                //     return staggerTimes[index];
                // }
            }, 0)

        function final() {
            gsap.to('.last', {scale: 2, duration: 0.2, repeat: 1, yoyo: true})
        }

        // = onresize ===========
        // window.onresize = () => {
        //     gsap.set('#scrollDist', {
        //         width: '100%',
        //         height: () => window.innerHeight * (scrollDist + 3),
        //     })
        // };
        console.log(point)
    }, [])

    return (
        <div id={"DesignProcess"}
             className={`relative h-[3000px]  mx-auto lg:w-[1024px] lg:h-[2000px]  xl:w-[1280px] `}>
            <div className={'absolute'} id="scrollDist"></div>
            <div id="container">
                <Content headline={header.headline}/>
                <svg id="map" className={`w-[341px] lg:w-[1082px]`}>
                    <path
                        className={`hidden lg:block`}
                        fill="#26F4BD"
                        id="line"
                        d="M 538.9338 -1.5 C 539.7623 -1.5 540.4338 -0.8284 540.4338 0 C 540.4338 41.4851 528.5232 78.7947 506.4931 105.7547 C 483.5788 133.797 450.8733 149.4034 411.5298 149.7128 L 339.1637 149.7174 C 256.672 149.7174 189.7995 216.5903 189.7995 299.0816 C 189.7995 380.7487 255.3409 447.1068 336.6937 448.4258 L 931.4548 448.51 C 1013.7092 450.8629 1079.3676 518.3173 1079.3676 600.81 C 1079.3676 684.4957 1014.1016 751.8159 931.5114 753.1539 L 242.4647 753.3383 C 109.9376 753.3383 1.5 861.7759 1.5 994.303 C 1.5 1125.5055 107.7794 1233.0965 238.4962 1235.2352 L 828.9514 1235.0432 C 913.0992 1235.0432 981.3156 1303.2596 981.3156 1387.4074 C 981.3156 1470.7144 914.4571 1538.4057 831.471 1539.7512 L 266.7701 1539.7716 C 184.2785 1539.7716 117.4059 1606.6445 117.4059 1689.1358 C 117.4059 1765.3645 174.77 1829.0348 249.664 1837.5342 l 2.2749 0.2407 l 10.1831 0.4961 L 251.4281 1831.55 C 250.768 1831.1351 250.5421 1830.2904 250.8853 1829.6077 L 250.9564 1829.4818 C 251.3713 1828.8216 252.2159 1828.5957 252.8986 1828.9389 L 253.0246 1829.01 L 268.5671 1838.7787 L 270.8249 1840.1978 L 268.4398 1841.3903 L 252.0203 1849.6002 C 251.2794 1849.9707 250.3784 1849.6704 250.0079 1848.9294 C 249.6592 1848.2321 249.9047 1847.3929 250.5525 1846.9877 L 250.6787 1846.917 L 261.977 1841.267 L 251.7194 1840.7659 C 174.1094 1833.1551 114.4059 1767.6816 114.4059 1689.1358 C 114.4059 1605.8291 181.2641 1538.1375 264.2505 1536.792 L 828.9514 1536.7716 C 911.4427 1536.7716 978.3156 1469.8991 978.3156 1387.4074 C 978.3156 1305.7414 912.7731 1239.3823 831.4222 1238.0632 L 242.4647 1238.2677 C 108.2804 1238.2677 -1.5 1128.4876 -1.5 994.303 C -1.5 861.4609 106.0962 752.5364 238.4467 750.3712 L 929.0035 750.1742 C 1011.107 750.1742 1076.3676 683.6964 1076.3676 600.81 C 1076.3676 519.9418 1012.0018 453.8153 931.3684 451.5087 L 339.1637 451.4458 C 255.0148 451.4458 186.7995 383.2305 186.7995 299.0816 C 186.7995 215.7749 253.6577 148.0834 336.644 146.7379 L 410.3356 146.7174 C 449.3132 146.7174 481.5954 131.4831 504.1701 103.8565 C 525.7379 77.4621 537.4338 40.8251 537.4338 0 C 537.4338 -0.8284 538.1054 -1.5 538.9338 -1.5 Z">
                    </path>

                    <path
                        className={`lg:hidden`}
                        fill="#26F4BD"
                        id="lineMobile"
                        d="M 171.5625 0 C 172.113281 0 172.5625 0.449219 172.5625 1 C 172.5625 34.386719 145.765625 61.515625 112.507812 62.058594 L 86.28125 62.066406 C 40.199219 62.066406 2.753906 99.046875 2.011719 144.953125 L 2 467.992188 C 2 522.121094 45.441406 566.105469 99.363281 566.980469 L 239.378906 566.992188 C 294.601562 566.992188 339.472656 611.3125 340.363281 666.320312 L 340.378906 958.496094 C 340.378906 1013.71875 296.058594 1058.589844 241.046875 1059.480469 L 101 1059.496094 C 46.871094 1059.496094 2.886719 1102.9375 2.011719 1156.859375 L 2 1710.507812 C 2 1764.636719 45.441406 1808.621094 99.363281 1809.492188 L 240 1809.507812 C 295.222656 1809.507812 340.09375 1853.824219 340.988281 1908.835938 L 341 2112.074219 C 341 2167.296875 296.679688 2212.167969 241.671875 2213.0625 L 101 2213.074219 C 46.871094 2213.074219 2.886719 2256.515625 2.011719 2310.4375 L 2 2707.589844 C 2 2752.101562 37.722656 2788.269531 82.066406 2788.988281 L 89.4375 2789 C 127.695312 2789 160.105469 2816.707031 166.394531 2854.035156 L 166.578125 2855.171875 L 167.226562 2863.246094 L 171.394531 2854.210938 C 171.625 2853.707031 172.21875 2853.488281 172.722656 2853.71875 C 173.1875 2853.933594 173.410156 2854.460938 173.253906 2854.9375 L 173.210938 2855.046875 L 167.445312 2867.550781 C 167.136719 2868.21875 166.25 2868.324219 165.785156 2867.789062 L 165.707031 2867.6875 L 158.015625 2856.269531 C 157.707031 2855.808594 157.828125 2855.1875 158.289062 2854.878906 C 158.714844 2854.59375 159.28125 2854.679688 159.605469 2855.058594 L 159.675781 2855.152344 L 165.234375 2863.40625 L 164.59375 2855.402344 C 158.988281 2818.914062 127.726562 2791.550781 90.566406 2791.007812 L 83.410156 2791 C 37.804688 2791 0.746094 2754.398438 0.0117188 2708.96875 L 0 2312.074219 C 0 2256.851562 44.320312 2211.980469 99.328125 2211.085938 L 240 2211.074219 C 294.128906 2211.074219 338.113281 2167.632812 338.988281 2113.710938 L 339 1910.507812 C 339 1856.378906 295.558594 1812.394531 241.636719 1811.519531 L 101 1811.507812 C 45.777344 1811.507812 0.90625 1767.1875 0.0117188 1712.175781 L 0 1158.496094 C 0 1103.273438 44.320312 1058.402344 99.328125 1057.507812 L 239.378906 1057.496094 C 293.507812 1057.496094 337.492188 1014.054688 338.367188 960.132812 L 338.378906 667.992188 C 338.378906 613.863281 294.9375 569.878906 241.015625 569.003906 L 101 568.992188 C 45.777344 568.992188 0.90625 524.671875 0.0117188 469.664062 L 0 146.347656 C 0 99.171875 37.859375 60.839844 84.855469 60.078125 L 111.496094 60.066406 C 144.117188 60.066406 170.5625 33.621094 170.5625 1 C 170.5625 0.449219 171.007812 0 171.5625 0 Z M 171.5625 0 "
                    >
                    </path>

                    <path id="theRoute" fill={"none"}
                          d="M 538.9338 -1.5 C 539.7623 -1.5 540.4338 -0.8284 540.4338 0 C 540.4338 41.4851 528.5232 78.7947 506.4931 105.7547 C 483.5788 133.797 450.8733 149.4034 411.5298 149.7128 L 339.1637 149.7174 C 256.672 149.7174 189.7995 216.5903 189.7995 299.0816 C 189.7995 380.7487 255.3409 447.1068 336.6937 448.4258 L 931.4548 448.51 C 1013.7092 450.8629 1079.3676 518.3173 1079.3676 600.81 C 1079.3676 684.4957 1014.1016 751.8159 931.5114 753.1539 L 242.4647 753.3383 C 109.9376 753.3383 1.5 861.7759 1.5 994.303 C 1.5 1125.5055 107.7794 1233.0965 238.4962 1235.2352 L 828.9514 1235.0432 C 913.0992 1235.0432 981.3156 1303.2596 981.3156 1387.4074 C 981.3156 1470.7144 914.4571 1538.4057 831.471 1539.7512 L 266.7701 1539.7716 C 184.2785 1539.7716 117.4059 1606.6445 117.4059 1689.1358 C 117.4059 1765.3645 174.77 1829.0348 249.664 1837.5342 l 2.2749 0.2407 l 10.1831 0.4961"
                    />

                    <path id="theRouteMobile" fill={"none"}
                          d="M 171.5625 0 C 172.1133 0 172.5625 0.4492 172.5625 1 C 172.5625 34.3867 145.7656 61.5156 112.5078 62.0586 L 86.2813 62.0664 C 40.1992 62.0664 2.7539 99.0469 2.0117 144.9531 L 2 467.9922 C 2 522.1211 45.4414 566.1055 99.3633 566.9805 L 239.3789 566.9922 C 294.6016 566.9922 339.4727 611.3125 340.3633 666.3203 L 340.3789 958.4961 C 340.3789 1013.7188 296.0586 1058.5898 241.0469 1059.4805 L 101 1059.4961 C 46.8711 1059.4961 2.8867 1102.9375 2.0117 1156.8594 L 2 1710.5078 C 2 1764.6367 45.4414 1808.6211 99.3633 1809.4922 L 240 1809.5078 C 295.2227 1809.5078 340.0938 1853.8242 340.9883 1908.8359 L 341 2112.0742 C 341 2167.2969 296.6797 2212.168 241.6719 2213.0625 L 101 2213.0742 C 46.8711 2213.0742 2.8867 2256.5156 2.0117 2310.4375 L 2 2707.5898 C 2 2752.1016 37.7227 2788.2695 82.0664 2788.9883 L 89.4375 2789 C 127.6953 2789 160.1055 2816.707 166.3945 2854.0352 l 0.1836 1.1367 l 0.6484 8.0742 "
                    />
                    <circle id="thePoint" fill={"#26F4BD"} r="12" cx={`${point === 'lg' ? '541' : '170'}`}></circle>
                    <text className="stop last text-xl bg-red-600" x="300" y="1852"></text>
                </svg>
            </div>

            {/*<img src={switchElement} className={`absolute`}/>*/}


            <img src={arrowElement} className={`rotate-180 absolute right-10 lg:left-32 top-16`} alt={""}/>
            <img src={plus} className={`absolute left:10 lg:right-32 top-0`} alt={""}/>
            <img src={tinyArrow}
                 className={`absolute hidden lg:block lg:top-[900px] xl:left-20 xl:top-[950px]`}
                 alt={""}
            />
            <img src={arrow}
                 className={`hidden lg:block absolute rotate-90 -right-16 lg:top-[900px] xl:right-10`}
                 alt={""}
            />

            {/*<div*/}
            {/*    className={`absolute hidden lg:block top-[25px] xl:top-[290px] lg:left-[500px] xl:left-[550px]`}>*/}
            {/*    <GenericLottie lottieAsset={bottle}/>*/}
            {/*</div>*/}


            <div className={`h-[1px]`}/>
            <Process process={kickOff}/>
            <Process process={research}/>

            <div className={`relative`}>
                <Process process={ux}/>
                <img src={star1} className={`absolute top-0 right-2 md:right-40   lg:top-0 lg:left-1/2`} alt={""}/>
                <img src={star2} className={`absolute top-10 right-5  md:right-44 lg:top-72 lg:left-40 xl:left-52`}
                     alt={""}/>
                <img src={star2} className={`absolute  top-72 right-5  md:right-44 lg:top-10 lg:right-20 xl:right-72`}
                     alt={""}/>
                <img src={curvedArrow}
                     className={`absolute lg:top-[125px] lg:left-1/2  xl:top-[125px] hidden lg:block`}
                     alt={""}/>
                <Process process={ui}/>
            </div>

            <div className={'lg:mt-10  flex flex-col lg:flex-row justify-center'}>
                <div className={`max-w-[200px] mx-auto lg:mx-0`}>
                    <GenericLottie lottieAsset={phone}/>
                </div>
                <Content
                    headline={brilliant.headline}
                    title={brilliant.title}
                />
            </div>
            <Process process={notGoingAnywhere} footerRef={footerRef}/>
            <img src={arrow} className={`hidden lg:block absolute rotate-90 -right-10 -bottom-40`} alt={""}/>
            <img src={floor} className={`hidden lg:block absolute -rotate-90  left-32 -bottom-40`}
                 alt={""}/>
        </div>
    )
}